module.exports = __webpack_public_path__ + "static/media/beamlineforschools.ffaf6d95.png";